import Matter from 'matter-js';

import { Dim, Entity } from '../../models';
import { posOf } from '../../helpers';
import Bar from '../renderers/Bar';

export default (
  windowDims: Dim,
  y: number,
  timing: number,
  fuzzy = true,
  state?: string
): Entity => {
  const dims = { w: windowDims.w, h: 0 };
  const body = Matter.Bodies.rectangle(windowDims.w / 2, y, dims.w, dims.h, {
    type: 'bar',
  });

  return {
    dims,
    getPos: () => posOf(body),
    body,
    timing,
    garbageTime: -1,
    fuzzy,
    state,
    renderer: Bar,
  };
};
